import Axios from 'axios'

const panicAlertService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = `${process.env.RESULTS_BASE_URL}`
    return AxiosInstance
  },
  getPanicAlerts(limit, startDate, endDate) {
    return this.axios().get('/panic', {
      params: {
        limit,
        startDate,
        endDate
      }
    })
  },
  getTotalPanicAlerts(limit, startDate, endDate) {
    return this.axios().get('/panic-count', {
      params: {
        limit,
        startDate,
        endDate
      }
    })
  },
  readPanicAlert(id) {
    return this.axios().put(`${id}`)
  }
}

export default panicAlertService
